import { Link, useLocation } from 'react-router-dom';

export function LoginPanelSwitcher({ active }) {
  const location = useLocation();
  const currentPath = location.pathname;

  const panels = [
    { id: 'employee', label: 'Employee', path: '/login' },
    { id: 'client', label: 'Client Portal', path: '/client/login' }
  ];

  const currentActive = active || (currentPath.includes('/client') ? 'client' : 'employee');

  return (
    <nav className="login-panel-switcher" aria-label="Select Login Portal">
      {panels.map((panel) => {
        const isActive = currentActive === panel.id;
        return (
          <Link
            key={panel.id}
            to={panel.path}
            className={`login-panel-tab${isActive ? ' login-panel-tab--active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
          >
            {panel.label}
          </Link>
        );
      })}
    </nav>
  );
}
